<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Scheduled Task Templates" class="pt-1">
          <div slot="no-body" class="mt-4">
            <!-- Button to Create template Page -->
            <div class="flex justify-end mb-4 mr-4">
                <vs-button v-can="'create-edit-scheduled-task-templates'" @click="onClickCreateTemplate()" class="mr-4 mb-4" color="primary" type="filled">Create</vs-button>
            </div>
            <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
              class="user-list-filters mb-8" :collapse-action="true">
              <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-full w-full">
                  <label class="text-sm opacity-100 text-bold">General</label>
                  <vs-input type="search" placeholder="Search.." v-model="filters['search']"
                    class="mb-4 md:mb-0 w-full" />
                </div>
              </div>
              <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                  <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                    v-on:click="filters = {}">CLEAR</vs-button>
                </div>
              </div>
            </vx-card>
            <!-- templates Table -->
            <vs-table :data="templates" stripe class="table-dark-inverted table-auto vs-con-loading__container">
                <template slot="thead">
                    <vs-th>Code</vs-th>
                    <vs-th>Name</vs-th>
                    <vs-th width="20%">Description</vs-th>
                    <!-- <vs-th>Frequency</vs-th>
                    <vs-th>Allocation</vs-th> -->
                    <vs-th>Status</vs-th>
                    <!-- <vs-th>Creator</vs-th> -->
                    <vs-th class="text-xs">ACTION</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr v-for="template in data" :key="template.id">
                        <vs-td>{{ template.code }}</vs-td>
                        <vs-td>{{ template.name }}</vs-td>
                        <vs-td>{{ template.description }}</vs-td>
                        <!-- <vs-td>{{ template.frequency }}</vs-td>
                        <vs-td>{{ template.allocation }}</vs-td> -->
                        <vs-td>{{ template.status }}</vs-td>
                        <!-- <vs-td>{{ template.creator ? template.creator.name : '' }}</vs-td> -->
                        <vs-td>
                            <div v-can="'create-edit-scheduled-task-templates'" class="vx-row">
                                <vx-tooltip  text="Edit Template" position="top">
                                    <vs-button class="mr-2"
                                            @click.stop="onClickViewTemplate(template)"
                                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                                </vx-tooltip>
                                  <div style="cursor: pointer" @click="onClickCopyTemplate(template.id)" class="prepend-text btn-addon">
                                    <vs-button icon-pack="feather" icon="icon-copy" size="small" type="border"
                                              color="primary"></vs-button>
                                  </div>
                                   <vx-tooltip v-if="template.status != 'In Active'" text="Set to Inactive" position="top">
                                  <div style="cursor: pointer" @click="deleteTemplate(template.id)" class="prepend-text btn-addon">
                                   <vs-button class="ml-2"  size="small"
                                   color="danger" type="border" icon-pack="feather" icon="icon-circle"></vs-button>
                                  </div>
                                  </vx-tooltip>
                                  <vx-tooltip v-if="template.status == 'In Active'" text="Set to Active" position="top">
                                  <div style="cursor: pointer" @click="setDraftTemplate(template.id)" class="prepend-text btn-addon">
                                   <vs-button class="ml-2"  size="small"
                                   color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                                  </div>
                                  </vx-tooltip>
                                   <vx-tooltip v-if="template.status == 'Draft'" text="Publish Template" position="top">
                                  <div style="cursor: pointer" @click="publishTemplate(template.id)" class="prepend-text btn-addon">
                                   <vs-button class="ml-2"  size="small"
                                   color="primary" type="border" icon-pack="feather" icon="icon-check"></vs-button>
                                  </div>
                                  </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5"
            ></vs-pagination>
          </div>
        </vx-card>
      </div>
         <CreateTemplate ref="createTemplate" />
    </div>
  </div>

</template>

<script>
import ScheduledTasksRepository from "@/repository/ScheduledTasksRepository";
import CreateTemplate from "../../../../../components/popups/settings/scheduled-tasks/CreateTemplate.vue";
import {defaultPagination, perPageList} from "@/constants/config";
import Filter from '@/mixins/filter';
export default {
name: "TaskTemplates",
data() {
  return {
    templates: [],
     filters: {},
      meta:{},
      page : 1,
      total: 0,
    perPage: defaultPagination,
    descriptionItems: perPageList,
  };
},
components: {
  CreateTemplate
},
mixins:[ Filter ],
methods: {
  async fetchTemplates() {
    try {
      const response = await ScheduledTasksRepository.getTemplates(this.filterQuery,this.perPage, this.page);
      this.templates = response.data.data || response.data;
      this.meta = response.data.meta
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  },
  onClickViewTemplate(template) {
    this.$router.push({path: `/pages/settings/templates/${template.id}`})
  },
  onClickCreateTemplate(){
    this.$refs.createTemplate.openPopup(
    );
  },
  async onClickCopyTemplate(id){
    try {
    const response = await ScheduledTasksRepository.copyTemplate(id);
    this.refreshData();
    } catch (error) {
      console.error("Error copying template:", error);
    }
  },
  refreshData(){
    this.fetchTemplates();
  },
  async deleteTemplate(id){
  try {
      const response = await ScheduledTasksRepository.deleteTemplate(id);
      this.refreshData();
      } catch (error) {
        console.error("Error making template inactive:", error);
      }
    },
  async setDraftTemplate(id){
  try {
      const response = await ScheduledTasksRepository.setDraftTemplate(id);
      this.refreshData();
      } catch (error) {
        console.error("Error making template inactive:", error);
      }
    },
  async publishTemplate(id){
  try {
      const response = await ScheduledTasksRepository.publishTemplate(id);
      this.refreshData();
      } catch (error) {
        console.error("Error making template inactive:", error);
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchTemplates()
    },
    filterQueryUpdate() {
    this.fetchTemplates()
    },
},
created() {
    this.fetchTemplates()
},
  watch: {
  page(){
    this.fetchTemplates()
  },
  perPage() {
    this.fetchTemplates()
  }
}
 
 
}
</script>

